// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__qyoZD","inputWrap":"CustomTip_inputWrap__3POHw"};